<style>
  input:disabled,
  select:disabled {
    cursor: no-drop;
  }

  input:disabled {
    color: #a8a8a8;
  }
</style>

<div class="arrange-pickup-dialog-header">
  <h3 style="font-size: 24px; margin-bottom: 0">Schedule Pickup</h3>
  <button (click)="closeWithoutAddItem()">
    <i class="fas fa-times" style="font-size: 24px; color: red"></i>
  </button>
</div>

<div mat-dialog-content>
  <mat-stepper
    headerPosition="bottom"
    linear
    class="shippn-b2b-create-shipment-stepper hide-stepper-header"
    [ngClass]="{'shippn-become-an-affiliate-stepper-step-1-done': currentStep}"
    [selectedIndex]="currentStep"
  >
    <mat-step [stepControl]="isForm1Completed">
      <div
        class="container"
        style="min-width: 360px; width: 600px; max-width: 800px"
      >
        <div class="row">
          <form
            class="col-12"
            ngNativeValidate
            [formGroup]="shipmentSelectionForm"
          >
            <div class="b2b-schedule-pickup-form-shipment-selection-wrapper">
              <div>
                <label for="searchKey">Search Shipment</label>
                <input
                  type="text"
                  class="form-control"
                  id="searchKey"
                  formControlName="searchKey"
                  placeholder="Search Shipment Number"
                  (input)="searchShipment()"
                />
              </div>
              <div>
                <label for="shipmentsListSelect">Select Shipment</label>
                <select
                  name="shipmentsListSelect"
                  class="form-control"
                  id="shipmentsListSelect"
                  formControlName="shipmentsListSelect"
                  (change)="selectShipment()"
                >
                  <option value="" disabled>Please select a Shipment</option>
                  <option
                    value="{{shipment.id}}"
                    *ngFor="let shipment  of shipmentsList"
                  >
                    {{shipment.shipment_number}}
                  </option>
                </select>
              </div>

              <div
                *ngIf="selectedShipment !== null && selectedShipment !== undefined && selectedShipment?.b2b_user_address?.street1"
              >
                <h6>Address Details</h6>
                <p>
                  {{selectedShipment?.b2b_user_address?.street1}}
                  {{selectedShipment?.b2b_user_address?.street2}}
                  {{selectedShipment?.b2b_user_address?.city}}
                  {{selectedShipment?.b2b_user_address?.state}}
                  {{selectedShipment?.b2b_user_address?.zip}}
                  {{selectedShipment?.b2b_user_address?.country}}
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </mat-step>
    <mat-step [stepControl]="secondFormGroup">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <form ngNativeValidate [formGroup]="form">
              <div class="container">
                <div class="arrange-pickup-main-wrapper">
                  <div class="col-date">
                    <div style="margin-bottom: 0; margin-top: 14px" class="form-group">
                      <p
                        style="
                          color: black;
                          font-size: 14px;
                          font-weight: 500;
                          margin-bottom: 10px;
                        "
                      >
                        Pick up date
                      </p>

                      <mat-form-field>
                        <input
                          matInput
                          [matDatepicker]="picker"
                          [matDatepickerFilter]="weekendFilter"
                          [min]="minDate"
                          (dateChange)="dateSelected($event)"
                          [max]="maxDate"
                          formControlName="pickUpDate"
                        />
                        <mat-datepicker-toggle
                          matIconSuffix
                          [for]="picker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="col-times">
                    <div style="margin-top: 14px">
                      <p
                        style="
                          color: black;
                          font-size: 14px;
                          font-weight: 500;
                          margin-bottom: 10px;
                        "
                      >
                        Between hours
                      </p>

                      <div class="b2b-arrange-pickup-time-picker-wrapper">
                        <div class="b2b-arrange-pickup-time-picker-from-time">
                          <label for="startTime" style="min-width: 50px">From</label>
                          <mat-form-field>
                            <input
                              matInput
                              name="selected_time_A"
                              [format]="24"
                              [min]="minStartTime"
                              [max]="maxStartTime"
                              [ngxMatTimepicker]="pickerA"
                              placeholder="09:00"
                              readonly
                              formControlName="startTime"
                              id="startTime"
                            />
                            <mat-icon matSuffix (click)="pickerA.open()">
                              watch_later
                            </mat-icon>
                            <ngx-mat-timepicker
                              timepickerClass="shippn-time-picker-arange-pickup"
                              #pickerA
                              [hoursOnly]="true"
                              matSuffix
                              (timeSet)="selectFromTime($event)"
                            ></ngx-mat-timepicker>
                          </mat-form-field>
                        </div>

                        <div class="b2b-arrange-pickup-time-picker-to-time">
                            <label for="endTime">To</label>
                            <mat-form-field>
                              <input
                                matInput
                                name="selected_time_B"
                                [format]="24"
                                [max]="maxEndTime"
                                [min]="minEndTime"
                                [ngxMatTimepicker]="pickerB"
                                placeholder="12:00"
                                readonly
                                [disabled]="isEndTimeSelectable"
                                formControlName="endTime"
                                id="endTime"
                              />
                              <mat-icon matSuffix (click)="pickerB.open()">
                                watch_later
                              </mat-icon>
                              <ngx-mat-timepicker
                                timepickerClass="shippn-time-picker-arange-pickup"
                                #pickerB
                                [hoursOnly]="true"
                                matSuffix
                                (timeSet)="selectEndTime($event)"
                              ></ngx-mat-timepicker>
                            </mat-form-field>
                        </div>
                      </div>

                      <div class="warning-box">
                        <p>
                          *The available pick up time period you specify must be at least
                          3 hours.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </mat-step>
  </mat-stepper>
  <div class="container">
    <div class="row">
      <div class="col-12" style="padding: 15px 30px">
        <div
          class="shippn-b2b-create-shipment-stepper-controls-wrapper"
          style="display: flex"
          [ngClass]="currentStep > 0 ? 'justify-space-between' : 'justify-flex-end'"
        >
          <button
            mat-flat-button
            class="shippn-mat-btn shippn-mat-btn-alt"
            (click)="movePrevStep()"
            *ngIf="currentStep > 0"
          >
            Back
          </button>
          <button
            mat-flat-button
            color="primary"
            class="shippn-mat-btn"
            (click)="moveNextStep()"
            [disabled]="!userCanMoveForward"
            *ngIf="currentStep == 0"
          >
            Next
          </button>

          <button
            *ngIf="currentStep == 1"
            [disabled]="!isFromTimeSelected || !isToTimeSelected || !isDateSelected"
            mat-flat-button
            color="primary"
            class="shippn-mat-btn"
            (click)="saveArrangePickUp()"
          >
            SAVE
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
